import { useEffect } from 'react'

import { Select } from '@percent/lemonade'
import { CountrySelectProps } from './CountrySelect.types'
import {
  FormState,
  SelectOption
} from '@percent/education-hosted-form/context/educationHostedForm/EducationHostedFormContext.types'
import { useCountries } from '@percent/education-hosted-form/hooks/useCountries/useCountries'
import { useEducationHostedForm } from '@percent/education-hosted-form/hooks/useEducationHostedForm/useEducationHostedForm'

export function CountrySelect({ value, isDisabled, supportedCountries, ...props }: CountrySelectProps) {
  const { setFormState } = useEducationHostedForm()

  const { countries, isError } = useCountries()
  const availableCountries = supportedCountries?.length
    ? countries.filter(country => supportedCountries.includes(country.code))
    : countries
  const countryCodes: SelectOption[] = availableCountries.map(country => ({ value: country.code, label: country.name }))

  useEffect(() => {
    if (isError) {
      setFormState(FormState.ERROR)
    }
  }, [isError, setFormState])

  return (
    <Select
      options={countryCodes}
      defaultValue={countryCodes.find(country => country.value === value)}
      searchable
      {...props}
      disabled={isDisabled}
    />
  )
}
